import { notifications } from '@mantine/notifications';
import {
  getAirlineKey,
  getAirlinesKey,
  useGetAirline,
  useUpdateAirline,
} from 'api-hooks/airline';
import { queryClient } from 'common/repositories/query-client';
import { useRouter } from 'next/router';

import AirlineForm from './components/form';

export default function AirlineView() {
  const { query } = useRouter();
  const id = query?.id as string;
  const queryView = useGetAirline(
    {
      id,
    },
    { enabled: !!id },
  );
  const updateMutation = useUpdateAirline();

  return (
    <AirlineForm
      query={queryView}
      saveMutation={updateMutation}
      onSubmit={async (input) => {
        const result = await updateMutation.mutateAsync({
          body: input,
          airlineId: id,
        });

        queryClient.refetchQueries([getAirlinesKey()[0]]);
        queryClient.refetchQueries(getAirlineKey({ id: result.data.id }));

        notifications.show({ message: result.message, color: 'green' });

        return result.data;
      }}
    />
  );
}
